"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FilterColors = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SystemIcon = _interopRequireDefault(require("../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  var _filter;

  return {
    filter: (_filter = {
      borderRadius: 20,
      fontSize: 18,
      lineHeight: "24px",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      transition: theme.transitions.create(["background-color", "color"], {
        duration: theme.transitions.duration.standard
      })
    }, _defineProperty(_filter, theme.breakpoints.down("xs"), {
      fontSize: 16,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    }), _defineProperty(_filter, "& .MuiButton-startIcon", {
      marginLeft: 0,
      marginRight: theme.spacing(1.5)
    }), _defineProperty(_filter, "& .MuiSvgIcon-root", {
      transition: theme.transitions.create(["stroke"], {
        duration: theme.transitions.duration.standard
      })
    }), _filter),
    grey: {
      color: theme.palette.grey[800],
      backgroundColor: theme.palette.grey[200],
      "&:hover": {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.grey[300],
        "& .MuiSvgIcon-root": {
          stroke: theme.palette.grey[800]
        }
      },
      "&.Mui-selected": {
        "&:hover ": {
          backgroundColor: theme.palette.grey[200]
        },
        "& .MuiSvgIcon-root": {
          stroke: theme.palette.grey[200]
        }
      }
    },
    white: {
      color: theme.palette.grey[800],
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        color: theme.palette.grey[800],
        backgroundColor: theme.palette.grey[200],
        "& .MuiSvgIcon-root": {
          stroke: theme.palette.grey[800]
        }
      },
      "&.Mui-selected": {
        "&:hover ": {
          backgroundColor: theme.palette.common.white,
          "& .MuiSvgIcon-root": {
            stroke: theme.palette.grey[800]
          }
        }
      }
    },
    selected: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        color: theme.palette.grey[800],
        "& .MuiSvgIcon-root": {
          stroke: theme.palette.grey[800]
        }
      },
      "& .MuiSvgIcon-root": {
        stroke: theme.palette.common.white
      }
    },
    icon: {
      "& > *:first-of-type": {
        fontSize: 18
      }
    }
  };
});
/**
 * **Filters are compact elements that represent an input, attribute, or action.**
 *
 * There are 2 colors of filters: Grey, White
 *
 * There is a selected state and an icon option
 */

var Filter = function Filter(_ref) {
  var _classNames;

  var color = _ref.color,
      title = _ref.title,
      selected = _ref.selected,
      icon = _ref.icon,
      action = _ref.action;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    onClick: function onClick() {
      return action && action();
    },
    startIcon: icon && /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: icon,
      size: "small",
      color: "grey"
    }),
    disableElevation: true,
    classes: {
      startIcon: styles.icon
    },
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.filter, true), _defineProperty(_classNames, styles[color], true), _defineProperty(_classNames, styles.selected, selected), _defineProperty(_classNames, "Mui-selected", selected), _classNames))
  }, title);
};

Filter.propTypes = {
  /** The title of the filter */
  title: _propTypes.default.string.isRequired,

  /** The key of the SystemIcon component */
  icon: _propTypes.default.string,

  /** The selected state of the filter */
  selected: _propTypes.default.bool,

  /** The available color variants of tghe filter */
  color: _propTypes.default.oneOf(["white", "grey"]),

  /** The call back function when press filter */
  action: _propTypes.default.func.isRequired
};
Filter.defaultProps = {
  selected: false,
  color: "white",
  icon: null
};
var FilterColors = ["white", "grey"];
exports.FilterColors = FilterColors;
var _default = Filter;
exports.default = _default;